import api from './api'

const fundMapBaseUrl = '/api/v1/fund-map'

export async function getMainCategories() {
  const resp = await api.get(`${fundMapBaseUrl}/main-categories`)
  return resp.data
}

export async function getMainCategoriesFilteredBySearchParams(data) {
  const resp = await api.get(`${fundMapBaseUrl}/main-categories/filtered`, { params: data })
  return resp.data
}

export async function getSubCategories() {
  const resp = await api.get(`${fundMapBaseUrl}/sub-categories`)
  return resp.data
}

export async function sendFundmapDataToCacheService(data) {
  const resp = await api.post(`${fundMapBaseUrl}/fund-map-data`, data)
  return resp.data
}

export async function getFundmapDataFromCacheService(id) {
  const resp = await api.get(`${fundMapBaseUrl}/fund-map-data/${id}`)
  return resp.data
}

export async function getCompetitions(getQueryParams) {
  const resp = await api.get(`${fundMapBaseUrl}/`, { params: getQueryParams })
  return resp.data
}

export async function getMatchingResultForCompetition(competitionId, companyId, searchParams) {
  const resp = await api.get(`${fundMapBaseUrl}/fund`, {
    params: { competitionId, companyId, searchParams }
  })

  return resp.data
}

export async function createFund(data) {
  const resp = await api.post(`${fundMapBaseUrl}/create-fund`, data)
  return resp.data
}

export async function patchFund(competitionId, data) {
  const resp = await api.patch(`${fundMapBaseUrl}/${competitionId}`, data)
  return resp.data
}
